<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 300 : 'auto'"
  >
    <template #activator="{ props }">
      <div v-bind="props">
        <slot name="default" />
      </div>
    </template>

    <v-card data-cy="dialog-pod-analytics">
      <v-card-title class="d-flex justify-space-between">
        {{ $t('routes.pod.analyticsDialog.title') }}
        <v-btn icon @click="dialog = false" :aria-label="$t('common.close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <PodAnalytics :pod-id="this.pod.id" />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          variant="text"
          @click="dialog = false"
        >
          {{ $t('common.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import PodAnalytics from '@/routes/pods2/components/PodAnalytics.vue';

export default {
  components: { PodAnalytics },
  mixins: [DialogActionKeys],
  name: 'PodAnalyticsDialog',
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    pod: {
      type: Object,
      required: true
    }
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
}
</script>

<style scoped>

</style>
